// Generated by scripts/exam/assemble-audio.py. Published files are immutable.
export const EXAM_RECORDINGS = {
    "Please leave the bag beside the desk.": {
        "file": "8b2fa8dd64c794149839.mp3",
        "bank": "en-exam1",
        "durationMs": 2069
    },
    "Please leave the bag under the desk.": {
        "file": "695aa3eeba2be999ab87.mp3",
        "bank": "en-exam1",
        "durationMs": 1899
    },
    "Please leave the umbrella beside the desk.": {
        "file": "dd6cd714b5e3396e9407.mp3",
        "bank": "en-exam1",
        "durationMs": 2283
    },
    "Please leave the umbrella under the desk.": {
        "file": "69d8a3bc7ef177d9042e.mp3",
        "bank": "en-exam1",
        "durationMs": 2133
    },
    "Could you put the book beside the counter?": {
        "file": "b15304234c4d857ba0c6.mp3",
        "bank": "en-exam1",
        "durationMs": 1941
    },
    "Could you put the book under the counter?": {
        "file": "b843ca318591a128041e.mp3",
        "bank": "en-exam1",
        "durationMs": 1792
    },
    "Could you put the magazine beside the counter?": {
        "file": "fc94ba519d91c49cdd9c.mp3",
        "bank": "en-exam1",
        "durationMs": 2283
    },
    "Could you put the magazine under the counter?": {
        "file": "b1ac479b76f4123fbcdd.mp3",
        "bank": "en-exam1",
        "durationMs": 2112
    },
    "You can find the backpack beside the bench.": {
        "file": "4942b3292a3326a59d02.mp3",
        "bank": "en-exam1",
        "durationMs": 2155
    },
    "You can find the backpack under the bench.": {
        "file": "1745641d3337d88b371d.mp3",
        "bank": "en-exam1",
        "durationMs": 1984
    },
    "You can find the umbrella beside the bench.": {
        "file": "bca6e9ff4befa2ebaf1b.mp3",
        "bank": "en-exam1",
        "durationMs": 2240
    },
    "You can find the umbrella under the bench.": {
        "file": "8f87576ebf4b93004369.mp3",
        "bank": "en-exam1",
        "durationMs": 2133
    },
    "The phone has been placed beside the bed.": {
        "file": "e2cf94ae63a33b9c57ac.mp3",
        "bank": "en-exam1",
        "durationMs": 2155
    },
    "The phone has been placed under the bed.": {
        "file": "3108eba1537c9adf6cde.mp3",
        "bank": "en-exam1",
        "durationMs": 2048
    },
    "The book has been placed beside the bed.": {
        "file": "a1c5a2ee2e9de6879cbe.mp3",
        "bank": "en-exam1",
        "durationMs": 2005
    },
    "The book has been placed under the bed.": {
        "file": "bf99ee7b2446707f82a0.mp3",
        "bank": "en-exam1",
        "durationMs": 1899
    },
    "Please keep the suitcase beside the door.": {
        "file": "5bf677a2c4ae1180c534.mp3",
        "bank": "en-exam1",
        "durationMs": 2325
    },
    "Please keep the suitcase in front of the door.": {
        "file": "c1160174a65fd81bfc95.mp3",
        "bank": "en-exam1",
        "durationMs": 2453
    },
    "Please keep the bag beside the door.": {
        "file": "2f9340f0130cab6d7500.mp3",
        "bank": "en-exam1",
        "durationMs": 2069
    },
    "Please keep the bag in front of the door.": {
        "file": "505034d27d8d92c78ad2.mp3",
        "bank": "en-exam1",
        "durationMs": 2133
    },
    "The book that I borrowed is beside the shelf.": {
        "file": "7f572d2d1b3876409cf5.mp3",
        "bank": "en-exam1",
        "durationMs": 2432
    },
    "The book that I borrowed is under the shelf.": {
        "file": "8d6cf39bb34ec5a59e07.mp3",
        "bank": "en-exam1",
        "durationMs": 2325
    },
    "The magazine that I borrowed is beside the shelf.": {
        "file": "a6e7ae6400d4a962a7a2.mp3",
        "bank": "en-exam1",
        "durationMs": 2752
    },
    "The magazine that I borrowed is under the shelf.": {
        "file": "1f074564b3a22ccd711b.mp3",
        "bank": "en-exam1",
        "durationMs": 2581
    },
    "I left the ticket beside the chair.": {
        "file": "205cc8b34f9781a8361a.mp3",
        "bank": "en-exam1",
        "durationMs": 1899
    },
    "I left the ticket under the chair.": {
        "file": "572cf6263723ce35486d.mp3",
        "bank": "en-exam1",
        "durationMs": 1792
    },
    "I left the phone beside the chair.": {
        "file": "bf0796c130679b8fc149.mp3",
        "bank": "en-exam1",
        "durationMs": 1813
    },
    "I left the phone under the chair.": {
        "file": "35b997cc6729c4f5bcb5.mp3",
        "bank": "en-exam1",
        "durationMs": 1664
    },
    "Please put the cup beside the sink.": {
        "file": "cdad909a07fbaee87fc6.mp3",
        "bank": "en-exam1",
        "durationMs": 1856
    },
    "Please put the cup under the sink.": {
        "file": "f9e6a241489a94df6f8d.mp3",
        "bank": "en-exam1",
        "durationMs": 1707
    },
    "Please put the plate beside the sink.": {
        "file": "46b8392769a03aa6b92f.mp3",
        "bank": "en-exam1",
        "durationMs": 1920
    },
    "Please put the plate under the sink.": {
        "file": "6102ae36599b9f9dfcb7.mp3",
        "bank": "en-exam1",
        "durationMs": 1707
    },
    "The staff member placed the backpack beside the locker.": {
        "file": "3212e5a9d6ba1f09e2fd.mp3",
        "bank": "en-exam1",
        "durationMs": 2795
    },
    "The staff member placed the backpack in front of the locker.": {
        "file": "a2a09aa056fe74913f88.mp3",
        "bank": "en-exam1",
        "durationMs": 3008
    },
    "The staff member placed the suitcase beside the locker.": {
        "file": "21508ba2cfd78fa7c9fc.mp3",
        "bank": "en-exam1",
        "durationMs": 2944
    },
    "The staff member placed the suitcase in front of the locker.": {
        "file": "c6cee933736e5a9bb2da.mp3",
        "bank": "en-exam1",
        "durationMs": 3157
    },
    "You will see the pencil beside the desk.": {
        "file": "981779e1e56e57c13672.mp3",
        "bank": "en-exam1",
        "durationMs": 2069
    },
    "You will see the pencil under the desk.": {
        "file": "abe83ac7274b82e38916.mp3",
        "bank": "en-exam1",
        "durationMs": 1984
    },
    "You will see the key beside the desk.": {
        "file": "a50180104d3522db5fb8.mp3",
        "bank": "en-exam1",
        "durationMs": 1899
    },
    "You will see the key under the desk.": {
        "file": "cb5c9c72e65750ec69be.mp3",
        "bank": "en-exam1",
        "durationMs": 1749
    },
    "Someone has left the newspaper beside the table.": {
        "file": "9556f2ca95e2716e5ab5.mp3",
        "bank": "en-exam1",
        "durationMs": 2624
    },
    "Someone has left the newspaper under the table.": {
        "file": "2be1edbf3bda3e5d523d.mp3",
        "bank": "en-exam1",
        "durationMs": 2432
    },
    "Someone has left the book beside the table.": {
        "file": "06bd5cb6fb09f9638ef0.mp3",
        "bank": "en-exam1",
        "durationMs": 2240
    },
    "Someone has left the book under the table.": {
        "file": "b1c09e6da2c2a9ce2a68.mp3",
        "bank": "en-exam1",
        "durationMs": 2069
    },
    "I found the key beside the sofa.": {
        "file": "9528ab57dcfbc768d895.mp3",
        "bank": "en-exam1",
        "durationMs": 1899
    },
    "I found the key under the sofa.": {
        "file": "c17986ba40d379322192.mp3",
        "bank": "en-exam1",
        "durationMs": 1749
    },
    "I found the phone beside the sofa.": {
        "file": "a4e3e5eb07b5e1dc2279.mp3",
        "bank": "en-exam1",
        "durationMs": 1920
    },
    "I found the phone under the sofa.": {
        "file": "f4e0e37b9c501a5e2893.mp3",
        "bank": "en-exam1",
        "durationMs": 1835
    },
    "You can collect the camera beside the counter.": {
        "file": "9d1cd32e26739b654b36.mp3",
        "bank": "en-exam1",
        "durationMs": 2347
    },
    "You can collect the camera under the counter.": {
        "file": "6b43fc69cbbb0e20c250.mp3",
        "bank": "en-exam1",
        "durationMs": 2133
    },
    "You can collect the bag beside the counter.": {
        "file": "710c0f9068bd27844da5.mp3",
        "bank": "en-exam1",
        "durationMs": 2283
    },
    "You can collect the bag under the counter.": {
        "file": "d6def1f8a710a40f8baa.mp3",
        "bank": "en-exam1",
        "durationMs": 2112
    },
    "Please set the ball beside the door.": {
        "file": "50c8f7c9f2a2b88702e6.mp3",
        "bank": "en-exam1",
        "durationMs": 2069
    },
    "Please set the ball in front of the door.": {
        "file": "5c328ec59fb63ced1a6d.mp3",
        "bank": "en-exam1",
        "durationMs": 2048
    },
    "Please set the backpack beside the door.": {
        "file": "5333111226b77bfe1b49.mp3",
        "bank": "en-exam1",
        "durationMs": 2155
    },
    "Please set the backpack in front of the door.": {
        "file": "8a5667b12fe28b857eb3.mp3",
        "bank": "en-exam1",
        "durationMs": 2283
    },
    "The umbrella was found beside the bench.": {
        "file": "aec9e60a70ee41fef77b.mp3",
        "bank": "en-exam1",
        "durationMs": 2197
    },
    "The umbrella was found under the bench.": {
        "file": "5173071082de180c1b30.mp3",
        "bank": "en-exam1",
        "durationMs": 2048
    },
    "The bag was found beside the bench.": {
        "file": "8ac148bd07b6108a4641.mp3",
        "bank": "en-exam1",
        "durationMs": 1920
    },
    "The bag was found under the bench.": {
        "file": "07fe44ffe77147d029ca.mp3",
        "bank": "en-exam1",
        "durationMs": 1707
    },
    "We need two books for the class.": {
        "file": "e41fa5ecf243f907b008.mp3",
        "bank": "en-exam1",
        "durationMs": 1643
    },
    "We need two pencils for the class.": {
        "file": "fdfcef0a24f999eff510.mp3",
        "bank": "en-exam1",
        "durationMs": 1835
    },
    "We need four books for the class.": {
        "file": "800b99c1b36a80e90ddc.mp3",
        "bank": "en-exam1",
        "durationMs": 1707
    },
    "We need four pencils for the class.": {
        "file": "41a528c6714f9771a6d7.mp3",
        "bank": "en-exam1",
        "durationMs": 1899
    },
    "Please return two books today.": {
        "file": "85fbbef7954fb3fec457.mp3",
        "bank": "en-exam1",
        "durationMs": 1792
    },
    "Please return two magazines today.": {
        "file": "6c9cf55ea0ff3b4d6491.mp3",
        "bank": "en-exam1",
        "durationMs": 2112
    },
    "Please return four books today.": {
        "file": "92d045bff5b748548392.mp3",
        "bank": "en-exam1",
        "durationMs": 1813
    },
    "Please return four magazines today.": {
        "file": "08893db7ae6fc0d6e971.mp3",
        "bank": "en-exam1",
        "durationMs": 2112
    },
    "I have packed two shirts for the trip.": {
        "file": "46e7deeca0ec2f698c2f.mp3",
        "bank": "en-exam1",
        "durationMs": 1899
    },
    "I have packed two socks for the trip.": {
        "file": "55b0c04bf0abf4bdc17e.mp3",
        "bank": "en-exam1",
        "durationMs": 1877
    },
    "I have packed four shirts for the trip.": {
        "file": "aa521f11176fe97c393e.mp3",
        "bank": "en-exam1",
        "durationMs": 1899
    },
    "I have packed four socks for the trip.": {
        "file": "465abc624311420b39d1.mp3",
        "bank": "en-exam1",
        "durationMs": 1877
    },
    "Please put two cups on the table.": {
        "file": "b861af8d4b05bf7a9176.mp3",
        "bank": "en-exam1",
        "durationMs": 1877
    },
    "Please put two plates on the table.": {
        "file": "56f4e9845855ea869929.mp3",
        "bank": "en-exam1",
        "durationMs": 1877
    },
    "Please put four cups on the table.": {
        "file": "c46e0b95a4cc8739b561.mp3",
        "bank": "en-exam1",
        "durationMs": 1920
    },
    "Please put four plates on the table.": {
        "file": "2863bd7cec81739917a0.mp3",
        "bank": "en-exam1",
        "durationMs": 1941
    },
    "The teacher has prepared two pencils.": {
        "file": "c4fc0a7bf1b720f01f3c.mp3",
        "bank": "en-exam1",
        "durationMs": 2133
    },
    "The teacher has prepared two papers.": {
        "file": "8db20719993dd390e435.mp3",
        "bank": "en-exam1",
        "durationMs": 2091
    },
    "The teacher has prepared four pencils.": {
        "file": "0c3ebb48324ca624a63a.mp3",
        "bank": "en-exam1",
        "durationMs": 2176
    },
    "The teacher has prepared four papers.": {
        "file": "a8da1fa2dd36cd62af72.mp3",
        "bank": "en-exam1",
        "durationMs": 2155
    },
    "Please bring two tickets to the station.": {
        "file": "81eea3e2e576d0242bc3.mp3",
        "bank": "en-exam1",
        "durationMs": 2133
    },
    "Please bring two cards to the station.": {
        "file": "be82b28ef2aa74983554.mp3",
        "bank": "en-exam1",
        "durationMs": 2091
    },
    "Please bring four tickets to the station.": {
        "file": "d0f9a4ac563f557a3eab.mp3",
        "bank": "en-exam1",
        "durationMs": 2155
    },
    "Please bring four cards to the station.": {
        "file": "3d8470a01fac2a3575f8.mp3",
        "bank": "en-exam1",
        "durationMs": 2197
    },
    "There are two books on the shelf.": {
        "file": "82545c6178fc54a1f769.mp3",
        "bank": "en-exam1",
        "durationMs": 1600
    },
    "There are two magazines on the shelf.": {
        "file": "25a5a531b6d897678727.mp3",
        "bank": "en-exam1",
        "durationMs": 1856
    },
    "There are four books on the shelf.": {
        "file": "c70e45ca1b264f791497.mp3",
        "bank": "en-exam1",
        "durationMs": 1728
    },
    "There are four magazines on the shelf.": {
        "file": "9e78387fe305caa19a92.mp3",
        "bank": "en-exam1",
        "durationMs": 1941
    },
    "Please buy two apples for lunch.": {
        "file": "5605e5b0fd92ba17d85e.mp3",
        "bank": "en-exam1",
        "durationMs": 1835
    },
    "Please buy two oranges for lunch.": {
        "file": "6195b56bb102a0740c8a.mp3",
        "bank": "en-exam1",
        "durationMs": 2069
    },
    "Please buy four apples for lunch.": {
        "file": "1e8437f1e8e2339c9d9c.mp3",
        "bank": "en-exam1",
        "durationMs": 1899
    },
    "Please buy four oranges for lunch.": {
        "file": "e02a51bd817d849b2734.mp3",
        "bank": "en-exam1",
        "durationMs": 2112
    },
    "Please prepare two keys for the guests.": {
        "file": "19d4225820c5540b331b.mp3",
        "bank": "en-exam1",
        "durationMs": 2048
    },
    "Please prepare two cards for the guests.": {
        "file": "effab4cd99be4e3f1e59.mp3",
        "bank": "en-exam1",
        "durationMs": 2091
    },
    "Please prepare four keys for the guests.": {
        "file": "7141fbf8983eace0bbe8.mp3",
        "bank": "en-exam1",
        "durationMs": 2091
    },
    "Please prepare four cards for the guests.": {
        "file": "0f01c6c473181e13cfa7.mp3",
        "bank": "en-exam1",
        "durationMs": 2133
    },
    "We have arranged two chairs by the wall.": {
        "file": "0b0616f9129c15cafa8c.mp3",
        "bank": "en-exam1",
        "durationMs": 2091
    },
    "We have arranged two balls by the wall.": {
        "file": "737d3ab14cbd14bbfb3b.mp3",
        "bank": "en-exam1",
        "durationMs": 2133
    },
    "We have arranged four chairs by the wall.": {
        "file": "7bacd16c1a50a6d5eb57.mp3",
        "bank": "en-exam1",
        "durationMs": 2155
    },
    "We have arranged four balls by the wall.": {
        "file": "90d0e86735349506ea87.mp3",
        "bank": "en-exam1",
        "durationMs": 2155
    },
    "I found two shirts in the basket.": {
        "file": "f326391d7ec4bf54a766.mp3",
        "bank": "en-exam1",
        "durationMs": 1920
    },
    "I found two socks in the basket.": {
        "file": "651136961410aa0560eb.mp3",
        "bank": "en-exam1",
        "durationMs": 1877
    },
    "I found four shirts in the basket.": {
        "file": "8f6d7b9435484b134432.mp3",
        "bank": "en-exam1",
        "durationMs": 1963
    },
    "I found four socks in the basket.": {
        "file": "a10da5f8eda0b7e855b7.mp3",
        "bank": "en-exam1",
        "durationMs": 1963
    },
    "There are two bicycles beside the station.": {
        "file": "d9981300907ecc3da940.mp3",
        "bank": "en-exam1",
        "durationMs": 2325
    },
    "There are two buses beside the station.": {
        "file": "e3c493f6a12bae76acff.mp3",
        "bank": "en-exam1",
        "durationMs": 2219
    },
    "There are four bicycles beside the station.": {
        "file": "d1d09c7507d057664179.mp3",
        "bank": "en-exam1",
        "durationMs": 2432
    },
    "There are four buses beside the station.": {
        "file": "68c2eb6360af2aca47cd.mp3",
        "bank": "en-exam1",
        "durationMs": 2261
    },
    "The librarian brought two newspapers to the table.": {
        "file": "534ab9e2182cd52c2ff4.mp3",
        "bank": "en-exam1",
        "durationMs": 2816
    },
    "The librarian brought two magazines to the table.": {
        "file": "5e4c6a3e156459c1fa52.mp3",
        "bank": "en-exam1",
        "durationMs": 2837
    },
    "The librarian brought four newspapers to the table.": {
        "file": "42a3660543b1c823664d.mp3",
        "bank": "en-exam1",
        "durationMs": 2965
    },
    "The librarian brought four magazines to the table.": {
        "file": "40a4580aa5b371832d99.mp3",
        "bank": "en-exam1",
        "durationMs": 2880
    },
    "We ordered two sandwiches for lunch.": {
        "file": "0dad55d67ff7e2f9bfa2.mp3",
        "bank": "en-exam1",
        "durationMs": 1963
    },
    "We ordered two bottles of water for lunch.": {
        "file": "5cc0b613c149541bf6ae.mp3",
        "bank": "en-exam1",
        "durationMs": 2133
    },
    "We ordered four sandwiches for lunch.": {
        "file": "a1ea12740351f7e059fe.mp3",
        "bank": "en-exam1",
        "durationMs": 1963
    },
    "We ordered four bottles of water for lunch.": {
        "file": "c7996c88dccaf87d940a.mp3",
        "bank": "en-exam1",
        "durationMs": 2240
    },
    "The students displayed two pictures.": {
        "file": "25ebdff49178bfe275d1.mp3",
        "bank": "en-exam1",
        "durationMs": 1984
    },
    "The students displayed two books.": {
        "file": "ff86104e31a0114c7e7a.mp3",
        "bank": "en-exam1",
        "durationMs": 1877
    },
    "The students displayed four pictures.": {
        "file": "21e067246555381e1644.mp3",
        "bank": "en-exam1",
        "durationMs": 2027
    },
    "The students displayed four books.": {
        "file": "0dbc4be6d431c55c244b.mp3",
        "bank": "en-exam1",
        "durationMs": 1877
    },
    "The student standing here is wearing a long scarf and holding a book.": {
        "file": "8799ff410715a5a1133f.mp3",
        "bank": "en-exam1",
        "durationMs": 3861
    },
    "The student standing here is wearing a long scarf and holding an umbrella.": {
        "file": "c55571d265413b4f8b0d.mp3",
        "bank": "en-exam1",
        "durationMs": 4139
    },
    "The student standing here is wearing a short scarf and holding a book.": {
        "file": "22003288400937f45826.mp3",
        "bank": "en-exam1",
        "durationMs": 3925
    },
    "The student standing here is wearing a short scarf and holding an umbrella.": {
        "file": "8bc22d4923f12b20e600.mp3",
        "bank": "en-exam1",
        "durationMs": 4181
    },
    "The woman who is standing is wearing round glasses and holding a bag.": {
        "file": "ee3f2e6972cd3cf43d21.mp3",
        "bank": "en-exam1",
        "durationMs": 4053
    },
    "The woman who is standing is wearing round glasses and holding a camera.": {
        "file": "47dbaa38715c71250b58.mp3",
        "bank": "en-exam1",
        "durationMs": 4117
    },
    "The woman who is standing is wearing square glasses and holding a bag.": {
        "file": "1bb482a6b66542e85f48.mp3",
        "bank": "en-exam1",
        "durationMs": 4032
    },
    "The woman who is standing is wearing square glasses and holding a camera.": {
        "file": "f6ff451880b4ed40636f.mp3",
        "bank": "en-exam1",
        "durationMs": 4117
    },
    "The man over there is wearing a large hat and holding a phone.": {
        "file": "dfffbb64a382a04098e8.mp3",
        "bank": "en-exam1",
        "durationMs": 3563
    },
    "The man over there is wearing a large hat and holding a newspaper.": {
        "file": "6ccd94a04f6beed3a297.mp3",
        "bank": "en-exam1",
        "durationMs": 3840
    },
    "The man over there is wearing a small hat and holding a phone.": {
        "file": "6ef63e8b9fc84b50812c.mp3",
        "bank": "en-exam1",
        "durationMs": 3456
    },
    "The man over there is wearing a small hat and holding a newspaper.": {
        "file": "85c67551f8e0aa35ceaf.mp3",
        "bank": "en-exam1",
        "durationMs": 3712
    },
    "The child near the window is wearing a shirt with long sleeves and holding a ball.": {
        "file": "e801687731f35eeb4f78.mp3",
        "bank": "en-exam1",
        "durationMs": 4523
    },
    "The child near the window is wearing a shirt with long sleeves and holding a book.": {
        "file": "449fe74b20e4553195cc.mp3",
        "bank": "en-exam1",
        "durationMs": 4480
    },
    "The child near the window is wearing a shirt with short sleeves and holding a ball.": {
        "file": "31e499a4a76fa65f0bb8.mp3",
        "bank": "en-exam1",
        "durationMs": 4480
    },
    "The child near the window is wearing a shirt with short sleeves and holding a book.": {
        "file": "9b373e74579652e2f763.mp3",
        "bank": "en-exam1",
        "durationMs": 4437
    },
    "The woman you are looking for is wearing a jacket with two pockets and holding a suitcase.": {
        "file": "80c6b6c35496fb40fae1.mp3",
        "bank": "en-exam1",
        "durationMs": 5099
    },
    "The woman you are looking for is wearing a jacket with two pockets and holding an umbrella.": {
        "file": "e4a775e7527e19ff69a8.mp3",
        "bank": "en-exam1",
        "durationMs": 5013
    },
    "The woman you are looking for is wearing a jacket with four pockets and holding a suitcase.": {
        "file": "747c5cf67a8ec8cc98a8.mp3",
        "bank": "en-exam1",
        "durationMs": 5205
    },
    "The woman you are looking for is wearing a jacket with four pockets and holding an umbrella.": {
        "file": "bf093ba246dcdd647d25.mp3",
        "bank": "en-exam1",
        "durationMs": 5163
    },
    "The student waiting for a friend is wearing a long scarf and holding a bag.": {
        "file": "590ee29450d58c529658.mp3",
        "bank": "en-exam1",
        "durationMs": 4395
    },
    "The student waiting for a friend is wearing a long scarf and holding a camera.": {
        "file": "ca0c6b76ab481e253260.mp3",
        "bank": "en-exam1",
        "durationMs": 4459
    },
    "The student waiting for a friend is wearing a short scarf and holding a bag.": {
        "file": "5d795f5e1b706c9757d9.mp3",
        "bank": "en-exam1",
        "durationMs": 4373
    },
    "The student waiting for a friend is wearing a short scarf and holding a camera.": {
        "file": "d64b1a499570f682e430.mp3",
        "bank": "en-exam1",
        "durationMs": 4544
    },
    "The man who has just arrived is wearing round glasses and holding a phone.": {
        "file": "0ab70eecf7e000c0ddf7.mp3",
        "bank": "en-exam1",
        "durationMs": 4288
    },
    "The man who has just arrived is wearing round glasses and holding a newspaper.": {
        "file": "e838a6e7cdc2db6785b6.mp3",
        "bank": "en-exam1",
        "durationMs": 4587
    },
    "The man who has just arrived is wearing square glasses and holding a phone.": {
        "file": "c227f7957d406ef7fb64.mp3",
        "bank": "en-exam1",
        "durationMs": 4309
    },
    "The man who has just arrived is wearing square glasses and holding a newspaper.": {
        "file": "fa7fb455bf4dcb361047.mp3",
        "bank": "en-exam1",
        "durationMs": 4587
    },
    "The child standing in the room is wearing a large hat and holding a ball.": {
        "file": "531e5190f0bb0643accc.mp3",
        "bank": "en-exam1",
        "durationMs": 4309
    },
    "The child standing in the room is wearing a large hat and holding a book.": {
        "file": "9e62e2b53e0603df0448.mp3",
        "bank": "en-exam1",
        "durationMs": 4181
    },
    "The child standing in the room is wearing a small hat and holding a ball.": {
        "file": "9e54b76c5c4a62083ffb.mp3",
        "bank": "en-exam1",
        "durationMs": 4139
    },
    "The child standing in the room is wearing a small hat and holding a book.": {
        "file": "26aa59eb1effa7b55a6d.mp3",
        "bank": "en-exam1",
        "durationMs": 4053
    },
    "The man I met yesterday is wearing a shirt with long sleeves and holding a suitcase.": {
        "file": "3a750765643a16d87856.mp3",
        "bank": "en-exam1",
        "durationMs": 4928
    },
    "The man I met yesterday is wearing a shirt with long sleeves and holding an umbrella.": {
        "file": "6af84d717d8076e24ac1.mp3",
        "bank": "en-exam1",
        "durationMs": 4864
    },
    "The man I met yesterday is wearing a shirt with short sleeves and holding a suitcase.": {
        "file": "2e25b956e6d00f2282db.mp3",
        "bank": "en-exam1",
        "durationMs": 4864
    },
    "The man I met yesterday is wearing a shirt with short sleeves and holding an umbrella.": {
        "file": "285d06b188af8537affe.mp3",
        "bank": "en-exam1",
        "durationMs": 4800
    },
    "The woman standing outside is wearing a jacket with two pockets and holding a book.": {
        "file": "97455d2316e48e41d387.mp3",
        "bank": "en-exam1",
        "durationMs": 4608
    },
    "The woman standing outside is wearing a jacket with two pockets and holding an umbrella.": {
        "file": "d1f5d078869ca714323f.mp3",
        "bank": "en-exam1",
        "durationMs": 4864
    },
    "The woman standing outside is wearing a jacket with four pockets and holding a book.": {
        "file": "f23b916c6331868cf9d3.mp3",
        "bank": "en-exam1",
        "durationMs": 4736
    },
    "The woman standing outside is wearing a jacket with four pockets and holding an umbrella.": {
        "file": "5b9439646b2fa2989e0a.mp3",
        "bank": "en-exam1",
        "durationMs": 4971
    },
    "Turn left at the bank.": {
        "file": "d81882f6ff9cf6ec9b0f.mp3",
        "bank": "en-exam1",
        "durationMs": 1301
    },
    "Turn left at the library.": {
        "file": "b3a3eeb6a707f93440cb.mp3",
        "bank": "en-exam1",
        "durationMs": 1536
    },
    "Turn right at the bank.": {
        "file": "2598c8b06429f76dbe3a.mp3",
        "bank": "en-exam1",
        "durationMs": 1323
    },
    "Turn right at the library.": {
        "file": "3e060dbfe494c3a96872.mp3",
        "bank": "en-exam1",
        "durationMs": 1557
    },
    "Please turn left at the hospital.": {
        "file": "6316e410813c3e7637d6.mp3",
        "bank": "en-exam1",
        "durationMs": 2005
    },
    "Please turn left at the station.": {
        "file": "0b91ea2c650815ab214c.mp3",
        "bank": "en-exam1",
        "durationMs": 1835
    },
    "Please turn right at the hospital.": {
        "file": "d9439efca13f9019cbdb.mp3",
        "bank": "en-exam1",
        "durationMs": 1984
    },
    "Please turn right at the station.": {
        "file": "8c79777121e13572df45.mp3",
        "bank": "en-exam1",
        "durationMs": 1792
    },
    "You should turn left at the shop.": {
        "file": "0c1ce8f9beeab930c2ce.mp3",
        "bank": "en-exam1",
        "durationMs": 1685
    },
    "You should turn left at the bank.": {
        "file": "5f0ae1873743efb67aa8.mp3",
        "bank": "en-exam1",
        "durationMs": 1643
    },
    "You should turn right at the shop.": {
        "file": "9f71e8c335eb11362d60.mp3",
        "bank": "en-exam1",
        "durationMs": 1664
    },
    "You should turn right at the bank.": {
        "file": "49e36f548d33d882eefb.mp3",
        "bank": "en-exam1",
        "durationMs": 1643
    },
    "You need to turn left at the library.": {
        "file": "269748bac948c31a1738.mp3",
        "bank": "en-exam1",
        "durationMs": 1941
    },
    "You need to turn left at the hospital.": {
        "file": "5f73e59c69e37c56b60f.mp3",
        "bank": "en-exam1",
        "durationMs": 1963
    },
    "You need to turn right at the library.": {
        "file": "a216cd85836da4e3f617.mp3",
        "bank": "en-exam1",
        "durationMs": 1941
    },
    "You need to turn right at the hospital.": {
        "file": "436c2c30bc2623cc6fc0.mp3",
        "bank": "en-exam1",
        "durationMs": 1984
    },
    "Could you turn left at the station?": {
        "file": "3048937dc36a824742a0.mp3",
        "bank": "en-exam1",
        "durationMs": 1792
    },
    "Could you turn left at the shop?": {
        "file": "4bc9b3f1856b2ade2d9a.mp3",
        "bank": "en-exam1",
        "durationMs": 1643
    },
    "Could you turn right at the station?": {
        "file": "d69763fdbe17df3dc8a1.mp3",
        "bank": "en-exam1",
        "durationMs": 1771
    },
    "Could you turn right at the shop?": {
        "file": "3d3bac3d2a77f93a3d7c.mp3",
        "bank": "en-exam1",
        "durationMs": 1600
    },
    "The bus leaves at seven thirty.": {
        "file": "debf184e03bffff579f2.mp3",
        "bank": "en-exam1",
        "durationMs": 1792
    },
    "The bus leaves at eight fifteen.": {
        "file": "4e9c650eb48f11307f7c.mp3",
        "bank": "en-exam1",
        "durationMs": 1792
    },
    "The train leaves at seven thirty.": {
        "file": "516713a0c9f29efcea36.mp3",
        "bank": "en-exam1",
        "durationMs": 1899
    },
    "The train leaves at eight fifteen.": {
        "file": "6d699d61e34d82556f63.mp3",
        "bank": "en-exam1",
        "durationMs": 1877
    },
    "The shop opens at nine ten.": {
        "file": "c65e0b4b166cd383a835.mp3",
        "bank": "en-exam1",
        "durationMs": 1771
    },
    "The shop opens at ten forty-five.": {
        "file": "a32ebadcd7c174edf131.mp3",
        "bank": "en-exam1",
        "durationMs": 2112
    },
    "The library opens at nine ten.": {
        "file": "ed7a916c268ba54f400b.mp3",
        "bank": "en-exam1",
        "durationMs": 1963
    },
    "The library opens at ten forty-five.": {
        "file": "70a806e6b1338f010a4f.mp3",
        "bank": "en-exam1",
        "durationMs": 2304
    },
    "The bus will arrive at half past six.": {
        "file": "6757aed92f948c215b25.mp3",
        "bank": "en-exam1",
        "durationMs": 2048
    },
    "The bus will arrive at a quarter past eight.": {
        "file": "c7da2b80ec8347f2e1f9.mp3",
        "bank": "en-exam1",
        "durationMs": 2283
    },
    "The train will arrive at half past six.": {
        "file": "244a1a3e0a844c344c84.mp3",
        "bank": "en-exam1",
        "durationMs": 2112
    },
    "The train will arrive at a quarter past eight.": {
        "file": "fa4954a9b6e28fe045ab.mp3",
        "bank": "en-exam1",
        "durationMs": 2283
    },
    "The shop closes at a quarter to five.": {
        "file": "b4c54ba8c0370e1fd7e2.mp3",
        "bank": "en-exam1",
        "durationMs": 2176
    },
    "The shop closes at half past six.": {
        "file": "93effcf99d72c9842d12.mp3",
        "bank": "en-exam1",
        "durationMs": 2027
    },
    "The library closes at a quarter to five.": {
        "file": "3eafad56631e8926eacb.mp3",
        "bank": "en-exam1",
        "durationMs": 2389
    },
    "The library closes at half past six.": {
        "file": "1c325c6f5789316e90cd.mp3",
        "bank": "en-exam1",
        "durationMs": 2240
    },
    "The bus is scheduled to leave at ten fifty.": {
        "file": "9899125c5cb1fdab1dfc.mp3",
        "bank": "en-exam1",
        "durationMs": 2389
    },
    "The bus is scheduled to leave at eleven twenty.": {
        "file": "30e43b0a41eeaad31fd1.mp3",
        "bank": "en-exam1",
        "durationMs": 2752
    },
    "The train is scheduled to leave at ten fifty.": {
        "file": "274c38bed3444fab974b.mp3",
        "bank": "en-exam1",
        "durationMs": 2411
    },
    "The train is scheduled to leave at eleven twenty.": {
        "file": "8e07012894bc04548ad0.mp3",
        "bank": "en-exam1",
        "durationMs": 2731
    },
    "Please leave the receipt on the counter.": {
        "file": "88cf58b2b6876d787a0f.mp3",
        "bank": "en-exam1",
        "durationMs": 2069
    },
    "Please leave the receipt under the counter.": {
        "file": "750c5dd3effcbc92a926.mp3",
        "bank": "en-exam1",
        "durationMs": 2155
    },
    "Please leave the card on the counter.": {
        "file": "e32b1737a61e89161c6b.mp3",
        "bank": "en-exam1",
        "durationMs": 1984
    },
    "Please leave the card under the counter.": {
        "file": "974b9675013c4a394204.mp3",
        "bank": "en-exam1",
        "durationMs": 2048
    },
    "The server found the phone under the table.": {
        "file": "4efa8c699424d77f3b88.mp3",
        "bank": "en-exam1",
        "durationMs": 2112
    },
    "The server found the phone beside the table.": {
        "file": "45219d97e1eee92c48db.mp3",
        "bank": "en-exam1",
        "durationMs": 2283
    },
    "The server found the key under the table.": {
        "file": "4850585785d50f8c215d.mp3",
        "bank": "en-exam1",
        "durationMs": 2048
    },
    "The server found the key beside the table.": {
        "file": "5e745f822b1edcdca007.mp3",
        "bank": "en-exam1",
        "durationMs": 2219
    },
    "Could you place the letter on the desk?": {
        "file": "a492ce8719d503f2e426.mp3",
        "bank": "en-exam1",
        "durationMs": 1877
    },
    "Could you place the letter under the desk?": {
        "file": "9f82d7c2923f7637fc34.mp3",
        "bank": "en-exam1",
        "durationMs": 1941
    },
    "Could you place the paper on the desk?": {
        "file": "89386833895eb1c39efa.mp3",
        "bank": "en-exam1",
        "durationMs": 1877
    },
    "Could you place the paper under the desk?": {
        "file": "33dbd55668b85c99acce.mp3",
        "bank": "en-exam1",
        "durationMs": 1963
    },
    "Please keep the bag beside the bench.": {
        "file": "dbe088e97da016f59ec9.mp3",
        "bank": "en-exam1",
        "durationMs": 2048
    },
    "Please keep the bag under the bench.": {
        "file": "0d94fdb420299575206d.mp3",
        "bank": "en-exam1",
        "durationMs": 1899
    },
    "Please keep the umbrella beside the bench.": {
        "file": "6becf02a863bc5c87d4d.mp3",
        "bank": "en-exam1",
        "durationMs": 2347
    },
    "Please keep the umbrella under the bench.": {
        "file": "367d7a276e5478d261b2.mp3",
        "bank": "en-exam1",
        "durationMs": 2112
    },
    "A visitor left the camera on the bench.": {
        "file": "fc41629bda30f2069dc8.mp3",
        "bank": "en-exam1",
        "durationMs": 2048
    },
    "A visitor left the camera under the bench.": {
        "file": "c06353f087924236f221.mp3",
        "bank": "en-exam1",
        "durationMs": 2133
    },
    "A visitor left the backpack on the bench.": {
        "file": "13d3557b0385e4373b3f.mp3",
        "bank": "en-exam1",
        "durationMs": 2133
    },
    "A visitor left the backpack under the bench.": {
        "file": "08236733627f044656bc.mp3",
        "bank": "en-exam1",
        "durationMs": 2261
    },
    "The customer has put the jacket on the chair.": {
        "file": "11f94ef4618c0fb7c6b5.mp3",
        "bank": "en-exam1",
        "durationMs": 2432
    },
    "The customer has put the jacket behind the chair.": {
        "file": "3778eae705070c11022c.mp3",
        "bank": "en-exam1",
        "durationMs": 2667
    },
    "The customer has put the scarf on the chair.": {
        "file": "5b81260d7966bf066f6e.mp3",
        "bank": "en-exam1",
        "durationMs": 2261
    },
    "The customer has put the scarf behind the chair.": {
        "file": "84b14790b0c314876e4c.mp3",
        "bank": "en-exam1",
        "durationMs": 2560
    },
    "Please put the cup on the counter.": {
        "file": "5cef66146e675ac5d2e2.mp3",
        "bank": "en-exam1",
        "durationMs": 1813
    },
    "Please put the cup under the counter.": {
        "file": "b4f60af3e552aaca4f9c.mp3",
        "bank": "en-exam1",
        "durationMs": 1856
    },
    "Please put the plate on the counter.": {
        "file": "b10382de0b982ffabed8.mp3",
        "bank": "en-exam1",
        "durationMs": 1835
    },
    "Please put the plate under the counter.": {
        "file": "e75db1fbbe84b276bd0f.mp3",
        "bank": "en-exam1",
        "durationMs": 1856
    },
    "You can find the laptop on the table.": {
        "file": "9158db5983d399601767.mp3",
        "bank": "en-exam1",
        "durationMs": 2091
    },
    "You can find the laptop under the table.": {
        "file": "57319d24ae539131834d.mp3",
        "bank": "en-exam1",
        "durationMs": 2091
    },
    "You can find the newspaper on the table.": {
        "file": "e2266f15444ca351fd03.mp3",
        "bank": "en-exam1",
        "durationMs": 2091
    },
    "You can find the newspaper under the table.": {
        "file": "289a7317758ce5f81ce4.mp3",
        "bank": "en-exam1",
        "durationMs": 2176
    },
    "Someone has left the ticket under the chair.": {
        "file": "6a1511336fc4f3056414.mp3",
        "bank": "en-exam1",
        "durationMs": 2219
    },
    "Someone has left the ticket beside the chair.": {
        "file": "2baf47d0c6964730d55c.mp3",
        "bank": "en-exam1",
        "durationMs": 2261
    },
    "Someone has left the magazine under the chair.": {
        "file": "f4d9fb4068dcf721a0df.mp3",
        "bank": "en-exam1",
        "durationMs": 2389
    },
    "Someone has left the magazine beside the chair.": {
        "file": "db68223d0707b0898948.mp3",
        "bank": "en-exam1",
        "durationMs": 2475
    },
    "The coach placed the ball in the basket.": {
        "file": "567e4250a112547f56d8.mp3",
        "bank": "en-exam1",
        "durationMs": 2048
    },
    "The coach placed the ball beside the basket.": {
        "file": "8bc9582fa16c68a84970.mp3",
        "bank": "en-exam1",
        "durationMs": 2325
    },
    "The coach placed the bottle in the basket.": {
        "file": "0b0aa4cea8a684c9b2af.mp3",
        "bank": "en-exam1",
        "durationMs": 2176
    },
    "The coach placed the bottle beside the basket.": {
        "file": "21d76c6081dd0bec64be.mp3",
        "bank": "en-exam1",
        "durationMs": 2411
    },
    "Please prepare two bags for today's event.": {
        "file": "19405d69a7fea8cd44c3.mp3",
        "bank": "en-exam1",
        "durationMs": 2389
    },
    "Please prepare two boxes for today's event.": {
        "file": "43f6d0a4178898ffbd5a.mp3",
        "bank": "en-exam1",
        "durationMs": 2496
    },
    "Please prepare three bags for today's event.": {
        "file": "687f4b1c8d57ca7b5ce6.mp3",
        "bank": "en-exam1",
        "durationMs": 2475
    },
    "Please prepare three boxes for today's event.": {
        "file": "6807d6a9955745bf8b89.mp3",
        "bank": "en-exam1",
        "durationMs": 2624
    },
    "We need two plates for the meeting.": {
        "file": "692992e8411abac58b56.mp3",
        "bank": "en-exam1",
        "durationMs": 1728
    },
    "We need two glasses for the meeting.": {
        "file": "a637f31fd787d13d54cc.mp3",
        "bank": "en-exam1",
        "durationMs": 1856
    },
    "We need three plates for the meeting.": {
        "file": "a76d13ea3843cc565a1f.mp3",
        "bank": "en-exam1",
        "durationMs": 1813
    },
    "We need three glasses for the meeting.": {
        "file": "c0af46785e14fb8efd55.mp3",
        "bank": "en-exam1",
        "durationMs": 1963
    },
    "The assistant has brought two books to the desk.": {
        "file": "6fc7e5993b55dce6f6c4.mp3",
        "bank": "en-exam1",
        "durationMs": 2368
    },
    "The assistant has brought two letters to the desk.": {
        "file": "e64f5d5a2c9454a06592.mp3",
        "bank": "en-exam1",
        "durationMs": 2517
    },
    "The assistant has brought three books to the desk.": {
        "file": "a7e61458c6bad5ad3604.mp3",
        "bank": "en-exam1",
        "durationMs": 2496
    },
    "The assistant has brought three letters to the desk.": {
        "file": "4012041d74360333a406.mp3",
        "bank": "en-exam1",
        "durationMs": 2581
    },
    "The volunteers counted two books this morning.": {
        "file": "7173e81499f757d12ba8.mp3",
        "bank": "en-exam1",
        "durationMs": 2688
    },
    "The volunteers counted two bottles this morning.": {
        "file": "595b825acf54db18997a.mp3",
        "bank": "en-exam1",
        "durationMs": 2923
    },
    "The volunteers counted three books this morning.": {
        "file": "334c23f41c41d51058d0.mp3",
        "bank": "en-exam1",
        "durationMs": 2731
    },
    "The volunteers counted three bottles this morning.": {
        "file": "edcaf165229918862413.mp3",
        "bank": "en-exam1",
        "durationMs": 2987
    },
    "Please collect two pencils from the table.": {
        "file": "528bd92d4b339a2afec7.mp3",
        "bank": "en-exam1",
        "durationMs": 2219
    },
    "Please collect two books from the table.": {
        "file": "36fb2ee9964eae4f6024.mp3",
        "bank": "en-exam1",
        "durationMs": 2069
    },
    "Please collect three pencils from the table.": {
        "file": "dc8ae3f00c616666dcba.mp3",
        "bank": "en-exam1",
        "durationMs": 2325
    },
    "Please collect three books from the table.": {
        "file": "95d71c56b586ed084401.mp3",
        "bank": "en-exam1",
        "durationMs": 2133
    },
    "The clerk put out two bottles on the shelf.": {
        "file": "687e9a5d3048809f42aa.mp3",
        "bank": "en-exam1",
        "durationMs": 2155
    },
    "The clerk put out two boxes on the shelf.": {
        "file": "8237f8daa8b2e684f627.mp3",
        "bank": "en-exam1",
        "durationMs": 2219
    },
    "The clerk put out three bottles on the shelf.": {
        "file": "dbf7a5d38df0060dbfa2.mp3",
        "bank": "en-exam1",
        "durationMs": 2325
    },
    "The clerk put out three boxes on the shelf.": {
        "file": "f10ab69bc557f92ff129.mp3",
        "bank": "en-exam1",
        "durationMs": 2389
    },
    "The customer ordered two sandwiches for lunch.": {
        "file": "f562d08df684140c54b8.mp3",
        "bank": "en-exam1",
        "durationMs": 2389
    },
    "The customer ordered two bottles of water for lunch.": {
        "file": "e1fda38913c69e498721.mp3",
        "bank": "en-exam1",
        "durationMs": 2667
    },
    "The customer ordered three sandwiches for lunch.": {
        "file": "a65c09bed33b26c12a82.mp3",
        "bank": "en-exam1",
        "durationMs": 2475
    },
    "The customer ordered three bottles of water for lunch.": {
        "file": "5cd30d766e96845fe62d.mp3",
        "bank": "en-exam1",
        "durationMs": 2795
    },
    "We have received two letters at the office.": {
        "file": "ca1cd8631f37f8c4b519.mp3",
        "bank": "en-exam1",
        "durationMs": 2133
    },
    "We have received two boxes at the office.": {
        "file": "74862e041ed970d197e4.mp3",
        "bank": "en-exam1",
        "durationMs": 2283
    },
    "We have received three letters at the office.": {
        "file": "d9aaa04646fc8d594ab8.mp3",
        "bank": "en-exam1",
        "durationMs": 2261
    },
    "We have received three boxes at the office.": {
        "file": "905503a412a0fc3fca54.mp3",
        "bank": "en-exam1",
        "durationMs": 2325
    },
    "The center provides two books in the lobby.": {
        "file": "5c563b7c644a751be33f.mp3",
        "bank": "en-exam1",
        "durationMs": 2261
    },
    "The center provides two magazines in the lobby.": {
        "file": "3e183dcd73f2ca9706a1.mp3",
        "bank": "en-exam1",
        "durationMs": 2581
    },
    "The center provides three books in the lobby.": {
        "file": "8b7fd1b01c7656b3b33d.mp3",
        "bank": "en-exam1",
        "durationMs": 2347
    },
    "The center provides three magazines in the lobby.": {
        "file": "3325d26140c270e57546.mp3",
        "bank": "en-exam1",
        "durationMs": 2645
    },
    "The team brought two balls to practice.": {
        "file": "e5b77f237b5bd371cd8f.mp3",
        "bank": "en-exam1",
        "durationMs": 2091
    },
    "The team brought two bottles to practice.": {
        "file": "35561edcc74fbb81284d.mp3",
        "bank": "en-exam1",
        "durationMs": 2155
    },
    "The team brought three balls to practice.": {
        "file": "b1bbeb17ed9a76813652.mp3",
        "bank": "en-exam1",
        "durationMs": 2176
    },
    "The team brought three bottles to practice.": {
        "file": "5829ff64169958aa5b57.mp3",
        "bank": "en-exam1",
        "durationMs": 2240
    },
    "The customer is wearing a long scarf and holding a bag.": {
        "file": "db630a0b724fab66b8b2.mp3",
        "bank": "en-exam1",
        "durationMs": 3264
    },
    "The customer is wearing a long scarf and holding an umbrella.": {
        "file": "019cde08c63c85dcc07e.mp3",
        "bank": "en-exam1",
        "durationMs": 3520
    },
    "The customer is wearing round glasses and holding a bag.": {
        "file": "0f2d788aa344516be64e.mp3",
        "bank": "en-exam1",
        "durationMs": 3264
    },
    "The customer is wearing round glasses and holding an umbrella.": {
        "file": "c932c678de1574b4ec0f.mp3",
        "bank": "en-exam1",
        "durationMs": 3477
    },
    "The woman is wearing a small hat and holding a menu.": {
        "file": "b48e86550360b3cdf5ee.mp3",
        "bank": "en-exam1",
        "durationMs": 2965
    },
    "The woman is wearing a small hat and holding a phone.": {
        "file": "2b33ff06fe5485f8b6a4.mp3",
        "bank": "en-exam1",
        "durationMs": 2923
    },
    "The woman is wearing a shirt with long sleeves and holding a menu.": {
        "file": "70bb37f025dd3ba0fab3.mp3",
        "bank": "en-exam1",
        "durationMs": 3691
    },
    "The woman is wearing a shirt with long sleeves and holding a phone.": {
        "file": "9363512af95e9321c1f5.mp3",
        "bank": "en-exam1",
        "durationMs": 3627
    },
    "The receptionist is wearing a jacket with four pockets and holding a card.": {
        "file": "368ce7f51406c9bf6492.mp3",
        "bank": "en-exam1",
        "durationMs": 4224
    },
    "The receptionist is wearing a jacket with four pockets and holding a key.": {
        "file": "955419c89198dce8db93.mp3",
        "bank": "en-exam1",
        "durationMs": 4224
    },
    "The receptionist is wearing square glasses and holding a card.": {
        "file": "bdcc9902a465b1af518f.mp3",
        "bank": "en-exam1",
        "durationMs": 3541
    },
    "The receptionist is wearing square glasses and holding a key.": {
        "file": "c1ae79148bcd0cd9f920.mp3",
        "bank": "en-exam1",
        "durationMs": 3520
    },
    "The volunteer is wearing a large hat and holding a ticket.": {
        "file": "4732f7fedb700e1f66eb.mp3",
        "bank": "en-exam1",
        "durationMs": 3456
    },
    "The volunteer is wearing a large hat and holding a camera.": {
        "file": "84efd61c9c4e5c30d3d7.mp3",
        "bank": "en-exam1",
        "durationMs": 3435
    },
    "The volunteer is wearing a short scarf and holding a ticket.": {
        "file": "7d537aec5a824a51ead9.mp3",
        "bank": "en-exam1",
        "durationMs": 3499
    },
    "The volunteer is wearing a short scarf and holding a camera.": {
        "file": "20d8d96ad5f4cdd3d289.mp3",
        "bank": "en-exam1",
        "durationMs": 3477
    },
    "The student is wearing a jacket with two pockets and holding a camera.": {
        "file": "1bb2da2e8562545bb289.mp3",
        "bank": "en-exam1",
        "durationMs": 3840
    },
    "The student is wearing a jacket with two pockets and holding a book.": {
        "file": "d9af69bc1b8713631326.mp3",
        "bank": "en-exam1",
        "durationMs": 3776
    },
    "The student is wearing round glasses and holding a camera.": {
        "file": "cb78fb4e82b084ff79a8.mp3",
        "bank": "en-exam1",
        "durationMs": 3285
    },
    "The student is wearing round glasses and holding a book.": {
        "file": "614ae910925e8422d654.mp3",
        "bank": "en-exam1",
        "durationMs": 3200
    },
    "On the counter, there are more cards than receipts.": {
        "file": "391108f62c38ac46a048.mp3",
        "bank": "en-exam1",
        "durationMs": 2773
    },
    "On the counter, there are more bags than receipts.": {
        "file": "26915b792e18638fa4e3.mp3",
        "bank": "en-exam1",
        "durationMs": 2688
    },
    "On the counter, there are fewer cards than receipts.": {
        "file": "97d7171b63d4c73fe3f7.mp3",
        "bank": "en-exam1",
        "durationMs": 2731
    },
    "On the counter, there are fewer bags than receipts.": {
        "file": "17e717e97d9765d3f3b6.mp3",
        "bank": "en-exam1",
        "durationMs": 2667
    },
    "On this table, there are more apples than plates.": {
        "file": "83794b0a2bee31c5c2e4.mp3",
        "bank": "en-exam1",
        "durationMs": 2752
    },
    "On this table, there are more oranges than plates.": {
        "file": "84a893e6c6e77c324da7.mp3",
        "bank": "en-exam1",
        "durationMs": 2944
    },
    "On this table, there are fewer apples than plates.": {
        "file": "70c686c49f400ed4cfb0.mp3",
        "bank": "en-exam1",
        "durationMs": 2901
    },
    "On this table, there are fewer oranges than plates.": {
        "file": "7c78ada4d5f417646866.mp3",
        "bank": "en-exam1",
        "durationMs": 3008
    },
    "In the supply room, there are more pens than boxes.": {
        "file": "81106ab596f0f621e805.mp3",
        "bank": "en-exam1",
        "durationMs": 2923
    },
    "In the supply room, there are more books than boxes.": {
        "file": "2618718b9a829817d196.mp3",
        "bank": "en-exam1",
        "durationMs": 2880
    },
    "In the supply room, there are fewer pens than boxes.": {
        "file": "794f403e89eba9cb24d5.mp3",
        "bank": "en-exam1",
        "durationMs": 3008
    },
    "In the supply room, there are fewer books than boxes.": {
        "file": "8600cbf79eb68bcef048.mp3",
        "bank": "en-exam1",
        "durationMs": 2944
    },
    "At the community center, there are more books than newspapers.": {
        "file": "9f2385dc654b3d2792ea.mp3",
        "bank": "en-exam1",
        "durationMs": 3179
    },
    "At the community center, there are more magazines than newspapers.": {
        "file": "9198bc10dc7eae037cc8.mp3",
        "bank": "en-exam1",
        "durationMs": 3563
    },
    "At the community center, there are fewer books than newspapers.": {
        "file": "df83a18585cccffad537.mp3",
        "bank": "en-exam1",
        "durationMs": 3328
    },
    "At the community center, there are fewer magazines than newspapers.": {
        "file": "24285db113811fcf0b22.mp3",
        "bank": "en-exam1",
        "durationMs": 3755
    },
    "At the rental desk, there are more balls than bags.": {
        "file": "a68ed71ba4457d61f2b4.mp3",
        "bank": "en-exam1",
        "durationMs": 2901
    },
    "At the rental desk, there are more books than bags.": {
        "file": "1a5befb13b0ee48ef75e.mp3",
        "bank": "en-exam1",
        "durationMs": 2709
    },
    "At the rental desk, there are fewer balls than bags.": {
        "file": "454194d984555a0539ad.mp3",
        "bank": "en-exam1",
        "durationMs": 3008
    },
    "At the rental desk, there are fewer books than bags.": {
        "file": "d900acf400112c28c569.mp3",
        "bank": "en-exam1",
        "durationMs": 2837
    },
    "In the packing area, there are more boxes than receipts.": {
        "file": "1d50134acd1a2fec799b.mp3",
        "bank": "en-exam1",
        "durationMs": 3115
    },
    "In the packing area, there are more bags than receipts.": {
        "file": "dfb3633ebce2dd644339.mp3",
        "bank": "en-exam1",
        "durationMs": 2987
    },
    "In the packing area, there are fewer boxes than receipts.": {
        "file": "49dd92d62f38175d516e.mp3",
        "bank": "en-exam1",
        "durationMs": 3264
    },
    "In the packing area, there are fewer bags than receipts.": {
        "file": "ff271e4639c0e69867d0.mp3",
        "bank": "en-exam1",
        "durationMs": 3093
    },
    "On the bakery shelf, there are more sandwiches than loaves.": {
        "file": "7f7cab8759b916ae26fc.mp3",
        "bank": "en-exam1",
        "durationMs": 3200
    },
    "On the bakery shelf, there are more bottles than loaves.": {
        "file": "cdf6ea5248514daffe9b.mp3",
        "bank": "en-exam1",
        "durationMs": 3072
    },
    "On the bakery shelf, there are fewer sandwiches than loaves.": {
        "file": "e6b48aab55b2d981af1a.mp3",
        "bank": "en-exam1",
        "durationMs": 3243
    },
    "On the bakery shelf, there are fewer bottles than loaves.": {
        "file": "78972f6b817f0f41a301.mp3",
        "bank": "en-exam1",
        "durationMs": 3157
    },
    "At reception, there are more letters than books.": {
        "file": "1e2e576cb56e349b8933.mp3",
        "bank": "en-exam1",
        "durationMs": 2496
    },
    "At reception, there are more papers than books.": {
        "file": "ee95389be5e9693d1f63.mp3",
        "bank": "en-exam1",
        "durationMs": 2517
    },
    "At reception, there are fewer letters than books.": {
        "file": "1e58a21b7e8922857069.mp3",
        "bank": "en-exam1",
        "durationMs": 2603
    },
    "At reception, there are fewer papers than books.": {
        "file": "5e3d180021aa89ae5f53.mp3",
        "bank": "en-exam1",
        "durationMs": 2752
    },
    "In the waiting room, there are more books than bottles.": {
        "file": "08cc61870f3ea55df1aa.mp3",
        "bank": "en-exam1",
        "durationMs": 2752
    },
    "In the waiting room, there are more magazines than bottles.": {
        "file": "499a626941082957caa6.mp3",
        "bank": "en-exam1",
        "durationMs": 3157
    },
    "In the waiting room, there are fewer books than bottles.": {
        "file": "86f0a8154eabf5c6eabd.mp3",
        "bank": "en-exam1",
        "durationMs": 2880
    },
    "In the waiting room, there are fewer magazines than bottles.": {
        "file": "a421bfac4a92ac3c3321.mp3",
        "bank": "en-exam1",
        "durationMs": 3264
    },
    "In the gallery, there are more photos than magazines.": {
        "file": "71c11b77d25ec0593b90.mp3",
        "bank": "en-exam1",
        "durationMs": 2965
    },
    "In the gallery, there are more books than magazines.": {
        "file": "70e61ecea915d86a695d.mp3",
        "bank": "en-exam1",
        "durationMs": 2581
    },
    "In the gallery, there are fewer photos than magazines.": {
        "file": "33f9a338d86e3e59d9f1.mp3",
        "bank": "en-exam1",
        "durationMs": 3029
    },
    "In the gallery, there are fewer books than magazines.": {
        "file": "2d349ee90919cfa0c4ea.mp3",
        "bank": "en-exam1",
        "durationMs": 2688
    },
    "The woman is reading at the table.": {
        "file": "c609deccb525e0a81342.mp3",
        "bank": "en-exam1",
        "durationMs": 1856
    },
    "The woman is reading on the bench.": {
        "file": "b214912ab238765f612d.mp3",
        "bank": "en-exam1",
        "durationMs": 1707
    },
    "The woman is writing at the table.": {
        "file": "62c644e547fda02b874d.mp3",
        "bank": "en-exam1",
        "durationMs": 1899
    },
    "The woman is writing on the bench.": {
        "file": "f1c0314e57bd3d2b6062.mp3",
        "bank": "en-exam1",
        "durationMs": 1813
    },
    "The employee is reading at the desk.": {
        "file": "b0711624941a38860032.mp3",
        "bank": "en-exam1",
        "durationMs": 1963
    },
    "The employee is reading on the bench.": {
        "file": "b3ed0996720f5b138be4.mp3",
        "bank": "en-exam1",
        "durationMs": 1941
    },
    "The employee is writing at the desk.": {
        "file": "27d5f1cffb3ed6ff117d.mp3",
        "bank": "en-exam1",
        "durationMs": 1984
    },
    "The employee is writing on the bench.": {
        "file": "1049df56995c2e72fb11.mp3",
        "bank": "en-exam1",
        "durationMs": 1984
    },
    "The visitor is reading at the desk.": {
        "file": "cf1c04b1406c2985a04b.mp3",
        "bank": "en-exam1",
        "durationMs": 1920
    },
    "The visitor is reading on the bench.": {
        "file": "04b1c246366022e236bf.mp3",
        "bank": "en-exam1",
        "durationMs": 1941
    },
    "The visitor is writing at the desk.": {
        "file": "5e7f59258385162b38f6.mp3",
        "bank": "en-exam1",
        "durationMs": 1963
    },
    "The visitor is writing on the bench.": {
        "file": "912cdc63d998465e4120.mp3",
        "bank": "en-exam1",
        "durationMs": 2005
    },
    "The student is reading at the desk.": {
        "file": "a18dd8a9a87aac69f3be.mp3",
        "bank": "en-exam1",
        "durationMs": 1984
    },
    "The student is reading on the bench.": {
        "file": "032374029e12c5b389cc.mp3",
        "bank": "en-exam1",
        "durationMs": 2005
    },
    "The student is writing at the desk.": {
        "file": "33dd8bf008c731f73848.mp3",
        "bank": "en-exam1",
        "durationMs": 1984
    },
    "The student is writing on the bench.": {
        "file": "b3725aa56029cc5ca328.mp3",
        "bank": "en-exam1",
        "durationMs": 2069
    },
    "The customer is reading at the desk.": {
        "file": "736fe93b7c68995f63a8.mp3",
        "bank": "en-exam1",
        "durationMs": 2027
    },
    "The customer is reading on the bench.": {
        "file": "43bc1635dd85199c5979.mp3",
        "bank": "en-exam1",
        "durationMs": 2048
    },
    "The customer is writing at the desk.": {
        "file": "45c2a4f680708d387b0e.mp3",
        "bank": "en-exam1",
        "durationMs": 2048
    },
    "The customer is writing on the bench.": {
        "file": "b0bb28de6e11390ebd6b.mp3",
        "bank": "en-exam1",
        "durationMs": 2069
    },
    "The man is reading at the desk.": {
        "file": "f8ef7f9d6f7ee019646a.mp3",
        "bank": "en-exam1",
        "durationMs": 1643
    },
    "The man is reading on the bench.": {
        "file": "f27bc01e0952087a6440.mp3",
        "bank": "en-exam1",
        "durationMs": 1685
    },
    "The man is writing at the desk.": {
        "file": "99196e7e790265001b85.mp3",
        "bank": "en-exam1",
        "durationMs": 1728
    },
    "The man is writing on the bench.": {
        "file": "3e5d9011895ded09155c.mp3",
        "bank": "en-exam1",
        "durationMs": 1707
    },
    "The manager is reading at the desk.": {
        "file": "15617e4f226bc63e56f6.mp3",
        "bank": "en-exam1",
        "durationMs": 2091
    },
    "The manager is reading on the bench.": {
        "file": "b53f35de635afe2831d3.mp3",
        "bank": "en-exam1",
        "durationMs": 2048
    },
    "The manager is writing at the desk.": {
        "file": "94560d817db8c75c7165.mp3",
        "bank": "en-exam1",
        "durationMs": 2112
    },
    "The manager is writing on the bench.": {
        "file": "5bd528a1b588ca07cb0c.mp3",
        "bank": "en-exam1",
        "durationMs": 2091
    },
    "The participant is reading at the desk.": {
        "file": "42b78a85c8a98580923d.mp3",
        "bank": "en-exam1",
        "durationMs": 2261
    },
    "The participant is reading on the bench.": {
        "file": "cdf40d70b139a77431f9.mp3",
        "bank": "en-exam1",
        "durationMs": 2240
    },
    "The participant is writing at the desk.": {
        "file": "f9e6181035af8f5efb57.mp3",
        "bank": "en-exam1",
        "durationMs": 2304
    },
    "The participant is writing on the bench.": {
        "file": "a1bde701b0c0293c7ca9.mp3",
        "bank": "en-exam1",
        "durationMs": 2389
    },
    "The child is reading at the desk.": {
        "file": "eb28200b39a0da7eca83.mp3",
        "bank": "en-exam1",
        "durationMs": 1835
    },
    "The child is reading on the bench.": {
        "file": "2ca31584bc3accd5fe8c.mp3",
        "bank": "en-exam1",
        "durationMs": 1877
    },
    "The child is writing at the desk.": {
        "file": "312a8affd33d9fa66d90.mp3",
        "bank": "en-exam1",
        "durationMs": 1941
    },
    "The child is writing on the bench.": {
        "file": "7aa7d69b41556d2bc476.mp3",
        "bank": "en-exam1",
        "durationMs": 1941
    },
    "The clerk is reading at the desk.": {
        "file": "965af1c0a31a908d6a37.mp3",
        "bank": "en-exam1",
        "durationMs": 1728
    },
    "The clerk is reading on the bench.": {
        "file": "3f308e463737542f4510.mp3",
        "bank": "en-exam1",
        "durationMs": 1749
    },
    "The clerk is writing at the desk.": {
        "file": "8a4652c3e20c95acd8b4.mp3",
        "bank": "en-exam1",
        "durationMs": 1835
    },
    "The clerk is writing on the bench.": {
        "file": "d4dd6a8982bc803c297b.mp3",
        "bank": "en-exam1",
        "durationMs": 1835
    },
    "At the bank, make a left turn.": {
        "file": "fa31a5d4f7472eaaf63b.mp3",
        "bank": "en-exam1",
        "durationMs": 1664
    },
    "At the shop, make a left turn.": {
        "file": "b4d32fd21590fc4b7c34.mp3",
        "bank": "en-exam1",
        "durationMs": 1728
    },
    "At the bank, make a right turn.": {
        "file": "6cd1d2d2d76caee4f4cc.mp3",
        "bank": "en-exam1",
        "durationMs": 1664
    },
    "At the shop, make a right turn.": {
        "file": "516b9cd010bd3f78d8fd.mp3",
        "bank": "en-exam1",
        "durationMs": 1749
    },
    "Continue to the station and then turn left.": {
        "file": "64dbf8c16a4602fb7b2f.mp3",
        "bank": "en-exam1",
        "durationMs": 2560
    },
    "Continue to the shop and then turn left.": {
        "file": "1c0303d6c2113dcfb002.mp3",
        "bank": "en-exam1",
        "durationMs": 2368
    },
    "Continue to the station and then turn right.": {
        "file": "e5e0e64a34ebbb1f9b55.mp3",
        "bank": "en-exam1",
        "durationMs": 2560
    },
    "Continue to the shop and then turn right.": {
        "file": "cf6168378459c460cc4b.mp3",
        "bank": "en-exam1",
        "durationMs": 2368
    },
    "Take the left turn beside the bank.": {
        "file": "45de974fe8937f6c9e87.mp3",
        "bank": "en-exam1",
        "durationMs": 1920
    },
    "Take the left turn beside the station.": {
        "file": "7af973eff9921f00c497.mp3",
        "bank": "en-exam1",
        "durationMs": 2069
    },
    "Take the right turn beside the bank.": {
        "file": "cc3f237f48a41e0652b6.mp3",
        "bank": "en-exam1",
        "durationMs": 1920
    },
    "Take the right turn beside the station.": {
        "file": "f35138b191fdea871e55.mp3",
        "bank": "en-exam1",
        "durationMs": 2091
    },
    "When you reach the library, turn left.": {
        "file": "7cb05f2244d6f3ed8cf7.mp3",
        "bank": "en-exam1",
        "durationMs": 2219
    },
    "When you reach the hospital, turn left.": {
        "file": "6c9c3eb7c6e9c2addc83.mp3",
        "bank": "en-exam1",
        "durationMs": 2240
    },
    "When you reach the library, turn right.": {
        "file": "790dc700db24f944c3e7.mp3",
        "bank": "en-exam1",
        "durationMs": 2155
    },
    "When you reach the hospital, turn right.": {
        "file": "26737e41ad3f49a1e04b.mp3",
        "bank": "en-exam1",
        "durationMs": 2155
    },
    "The marked route turns left at the library.": {
        "file": "57a9cc8e9ada5747d8da.mp3",
        "bank": "en-exam1",
        "durationMs": 2240
    },
    "The marked route turns left at the station.": {
        "file": "76c644480ecb99242089.mp3",
        "bank": "en-exam1",
        "durationMs": 2197
    },
    "The marked route turns right at the library.": {
        "file": "47edd82d4cecd468eae1.mp3",
        "bank": "en-exam1",
        "durationMs": 2453
    },
    "The marked route turns right at the station.": {
        "file": "f5f885adb42086242909.mp3",
        "bank": "en-exam1",
        "durationMs": 2368
    }
};
//# sourceMappingURL=exam-recordings.js.map